import { apiClient } from './client';

/**
 * Downloads a program file by ID.
 * GET /api/v1/program-files/{program_file_id}/download
 */
export const downloadProgramFile = async (programFileId: string): Promise<Blob> => {
  const response = await apiClient.get(`/program-files/${programFileId}/download`, {
    responseType: 'blob',
  });
  return response.data;
};

/**
 * Fetches the text content of a program file by ID.
 * GET /api/v1/program-files/{program_file_id}/download
 */
export const getProgramFileContent = async (programFileId: string): Promise<string> => {
  const response = await apiClient.get(`/program-files/${programFileId}/download`, {
    responseType: 'text',
  });
  return response.data;
};

export const deleteProgramFile = async (programFileId: string): Promise<void> => {
  await apiClient.delete(`/program-files/${programFileId}`);
};
